import { get } from "lodash";
import React, { useMemo } from "react";
import { getMonthWithValues } from "../../../../../../utils/transformChartsAndTableData";
import GraphTable from "../../../../../../components/Common/GraphTable";


const GraphTableView = ({ graphTableData, chartOptions }) => {
    const finalData = useMemo(() => ({
        ...graphTableData,
        table_rows: get(graphTableData, 'table_rows', []).map(row => {
            const monthData = getMonthWithValues(row);
            const options = {
                ...chartOptions,
                xAxis: {
                    ...chartOptions.xAxis,
                    categories: monthData.months
                },
                series: chartOptions.series.map((s, i) => ({
                    ...s,
                    data: i === 0 ? monthData.data : s.data
                }))
            };
            return {
                ...row,
                nested_row: []
            };
        })
    }), [graphTableData, chartOptions]);

    return <GraphTable graph_table_data={{ table_data: finalData }} />;
};
export default GraphTableView